// For explanation purpose:
// ContentLayoutComponent => A shell component that provides the main (logged‑in) layout – header,
// sidebar, etc. All “inside‑app” pages will be rendered inside its <router-outlet>.

// content => An array of child routes (e.g. dashboard, profile, …) that appear inside
// ContentLayoutComponent.

// authen	=> Child routes that belong to the auth layout (login, register …).
import { Routes } from '@angular/router';
import { ContentLayoutComponent } from './shared/layouts/content-layout/content-layout.component';
import { content } from '@/core/routes/content.routes';
import { AuthenticationLayoutComponent } from './shared/layouts/authentication-layout/authentication-layout.component';
import { authen } from '@/core/routes/auth.routes';
import { AuthGuard } from '@/core/security/auth.guard';
import {admin} from "@/core/routes/admin.routes";
import {adminGuard} from "@/core/security/admin.guard";

export const routes: Routes = [
    { path: '', redirectTo: 'auth/login', pathMatch: 'full' },
    { path: '', component: ContentLayoutComponent, children: content, canActivate: [AuthGuard] },
    { path: 'admin', component: AuthenticationLayoutComponent, children: admin, canActivate: [adminGuard] },
    { path: 'auth', component: AuthenticationLayoutComponent, children: authen },

    {
      path: '**',
      redirectTo: 'dashboard',
    }
];
